import { useMemo } from 'react';

import { useParams } from 'react-router-dom';

import { DocumentViewer } from '@/new/components/doc-viewer/document-viewer';
import { BoundingBox, TimeRange } from '@/types';

export const ChunkDocViewer = ({
  docId,
  chunkId,
  boundingBoxes,
  timeRanges,
  fileExtension,
}: {
  docId: string;
  chunkId: string;
  boundingBoxes: BoundingBox[] | null;
  timeRanges: TimeRange[] | null;
  fileExtension?: string;
}) => {
  const { matterId } = useParams();

  const coordinates = useMemo(() => {
    return (boundingBoxes ?? [])
      .map((boundingBox) => ({
        ...boundingBox,
        id: chunkId,
      }))
      .toSorted((a, b) => a.pageNumber - b.pageNumber || a.top - b.top);
  }, [boundingBoxes, chunkId]);

  const timeHighlights = useMemo(
    () =>
      (timeRanges ?? [])
        .map((timeRange) => ({ ...timeRange, id: chunkId }))
        .toSorted((a, b) => a.startSeconds - b.startSeconds),
    [timeRanges, chunkId],
  );

  return (
    <div className="flex h-full flex-col">
      <div className="flex-grow overflow-hidden">
        <div className="relative h-full">
          <DocumentViewer
            matterId={matterId}
            fileExtension={fileExtension}
            docId={docId}
            highlights={coordinates}
            timeHighlights={timeHighlights}
            highlightedFactId={chunkId}
          />
        </div>
      </div>
    </div>
  );
};
